<template>
  <div>
    <h2 class="page-title">个人中心</h2>
    <div class="flex-box">
      <template v-if="RoleCode =='Web_Tourist'">
        <div class="button-showcase" @click="turnTo('/My/MemberCenter')">
          <i class="el-icon-user-solid"></i> 成为代理
        </div>
        <div class="button-showcase" @click="turnTo('/My/MemberCenter')">
          <i class="el-icon-s-platform"></i> 成为运营中心
        </div>
        <div class="button-showcase" @click="turnTo('/My/CaseManagement')">
          <i class="el-icon-circle-plus"></i> 提交案件
        </div>
      </template>
      <template v-else-if="RoleCode =='Web_AgentPerson'">
        <div class="button-showcase" @click="turnTo('/My/MemberCenter')">
          <i class="el-icon-s-platform"></i> 成为运营中心
        </div>
        <div class="button-showcase" @click="turnTo('/My/CaseManagement')">
          <i class="el-icon-circle-plus"></i> 提交案件
        </div>
      </template>
      <template v-else-if="RoleCode =='Web_AgentCompany'">
        <div class="button-showcase" @click="turnTo('/My/CaseManagement')">
          <i class="el-icon-circle-plus"></i> 提交案件
        </div>
      </template>
    </div>
    <h2 class="page-title">个人信息</h2>
     <div style="display: flex;align-items: center;margin-top: 20px;gap: 20px;">
      <div style="font-size: 16px;font-weight: 600">昵称：{{userInfo.NickName || ''}}<i class="el-icon-edit" style="cursor: pointer;" @click="editName"></i></div>
      <div style="display: flex;align-items: center;gap: 10px;">
        <img v-if="userInfo.AgentType ==1" style="width: 30px;" src="https://sdyusen.com.cn:8081/CloudSaveFile/wxindex/agent/yyzxfont.png"/>
        <img v-if="userInfo.AgentType ==2" style="width: 30px;" src="https://sdyusen.com.cn:8081/CloudSaveFile/wxindex/agent/dlfont.png"/>
        <div style="background: #DCDFE6;border-radius: 5px;padding: 5px 10px;">{{userInfo.AgentName}}</div>
      </div>
      
    </div>
    <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;">
      <div style="font-size: 16px;font-weight: 600">绑定手机号：{{phone}}</div>
      <div><el-link type="primary" @click="editPassword">修改密码</el-link></div>
    </div>
    <el-dialog width="500px" center title="修改密码" :append-to-body="true" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="手机号" prop="Phone">
          <el-input disabled v-model="registerForm.Phone"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" prop="VCode">
          <el-input v-model="registerForm.VCode">
            <el-button :disabled="disBtn" slot="append" @click="getCode">{{btnName}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="Password">
          <el-input v-model="registerForm.Password" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="RePassword">
          <el-input v-model="registerForm.RePassword" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePass">保 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script type="text/javascript">
  import wsManager from '@/utils/websocket'
  export default {
    components: {
    },
    props: {
      screen:{
        type: Object,
        default: () => {}
      },
    },
    data() {
      let validateConfirmPassword = (rule, value, callback) => {
        if (value !== this.registerForm.Password) {
          callback(new Error('两次输入的密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        url:{
          GetWxUrlPromotion: SZH.assets.api + '/WeChat/GetWxUrlPromotion',//
          GetControlPanel: SZH.assets.api + '/Custom/GetControlPanel',
          SendCode: SZH.assets.api + '/Custom/SendCode',
          UpdateCustomPassword: SZH.assets.api + '/Custom/UpdateCustomPassword',
          menusUrl: SZH.assets.api + '/ClientsData/GetClientsDataJson',
          GetUserData: SZH.assets.api + '/Custom/GetUserData',
          SetNickName: SZH.assets.api + '/Custom/SetNickName',//设置昵称
        },
        phone:'',
        registerForm:{
          Password:'', // 登录密码
          RePassword:'', // 登录密码
          Phone:'', // 手机号
          VCode:'', // 短信验证码
        },
        rules: {

          Password: [
            {
              required: true,
              message: '请输入登录密码',
              trigger: 'blur'
            },
            {
              validator: validatePassword,
              trigger: 'blur'
            }
          ],
          RePassword: [
            {
              required: true,
              message: '请再次输入密码',
              trigger: 'blur'
            },
            {
              validator: validateConfirmPassword,
              trigger: 'blur'
            }
          ],
          Phone: [
            {
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            },
            {
              validator: validatePhone,
              trigger: 'blur'
            }
          ],
          VCode: [
            {
              required: true,
              message: '请输入短信验证码',
              trigger: 'blur'
            }
          ],

        },
        btnName:'获取验证码',
        setintIndex:null,
        sendVCodeTime:59,
        disBtn:false,
        dialogFormVisible:false,
        RoleCode:'',
        userInfo:{}
      }
    },
    methods: {
      editName(){
        let self = this;
        self.$prompt('请输入昵称', '提示', {
          confirmButtonText: '确定',
          center:true,
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '不能为空'
        }).then(({ value }) => {
          self.loading = true;
          self.$http.post(self.url.SetNickName,{
            nickName:value
          })
            .then(result => {
              if (result.state == true) {
                self.$message.success('设置成功');
                self.getUser();
                self.loading = false;
              } else {
                self.loading = false;
                self.$message.error(result.message);
              }
            }, () => {
              self.loading = false;
              // 请求失败
              self.$message.error('登录失败，请检查您的网络是否可用。');
            });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      },
      getMenus(){
        let self = this;
        self.loading = true;
        self.menus = [];
        self.$http.post(self.url.menusUrl,{})
          .then(result => {
            if (result.state == true) {
              self.RoleCode = result.data.user.RoleCode;
              self.loading = false;
            } else {
              self.RoleCode = '';
              self.loading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      getUser(){
        let self = this;
        self.$http.post(self.url.GetUserData,{})
          .then(result => {
            if (result.state == true) {
              self.userInfo = result.data;
            } else {
              self.userInfo = {};
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      editPassword(){
        let self = this;
        self.dialogFormVisible = true;
        self.registerForm.Password = '';
        self.registerForm.Phone = localStorage.getItem('PhoneNo');
        self.registerForm.RePassword = '';
        self.registerForm.VCode = '';
      },
      getCode(){
        let self = this;
        if(!self.registerForm.Phone){
          self.$message.error('请输入手机号！');
          return
        }
        self.disBtn = true;
        //如果存在定时器不再调用接口
        if(self.setintIndex){
          return
        }
        //TODO
        self.sendVerifyCodeForRegisterFun();
        //调用接口成功调用下面的方法

      },
      sendVerifyCodeForRegisterFun(){
        let self = this;
        self.$http.post(self.url.SendCode, {
          Phone:self.registerForm.Phone
        }).then(result => {
          if (result.state == true) {
            self.$message.success('短信发送成功!');
            self.getReturnTime();
          } else {
            self.disBtn = false;
            self.$message.error(result.message);
          }
        }, () => {
          // 请求失败
          self.$message.error('注册失败，请检查您的网络是否可用。');
        });
      },
      getReturnTime(){
        this.btnName = '倒计时:'+this.sendVCodeTime+'s';
        this.setintIndex = setInterval(()=>{
          --this.sendVCodeTime;
          this.btnName = '倒计时:'+this.sendVCodeTime+'s';
          if(this.sendVCodeTime == 0){
            window.clearInterval(this.setintIndex);
            this.setintIndex = null;
            this.disBtn = false;
            this.btnName = '获取验证码';
            this.sendVCodeTime = 59;
          }
        },1000)
      },
      savePass(){
        let self = this;
        self.$refs['registerForm'].validate((valid) => {
          if (valid) {
            self.fullscreenLoading = true;
            self.$http.post(self.url.UpdateCustomPassword,  self.registerForm)
              .then(result => {
                if (result.state == true) { // 注册成功
                  self.$message.success('修改成功!');
                  self.dialogFormVisible = false
                } else {
                  self.$message.error(result.message);
                  // self.refreshCaptcha();
                }
                self.fullscreenLoading = false;
              }, () => {
                // 请求失败
                self.$message.error('注册失败，请检查您的网络是否可用。');
                self.fullscreenLoading = false;
              });
          } else {
            return false;
          }
        });
      },
      getConnect(){
        let self = this;
        self.$http.post(self.url.GetControlPanel,{})
          .then(result => {
            if (result.state == true) {
              wsManager.connectIfNeeded();
            } else {
              wsManager.connectIfNeeded();
            }

          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      turnTo(url){
        this.$router.push({
          path: url
        });
      },
    },
    computed: {
    },
    created() {
    },
    mounted() {
      this.phone = localStorage.getItem('PhoneNo');;
      this.getConnect();
      this.getMenus();
      this.getUser();
    },
    watch: {}
  }
</script>

<style type="text/css" scoped>

  .flex-box{
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 20px;
  }
  /* 优雅卡片：磨砂玻璃质感 + 精致阴影 */
  .button-showcase {
    font-size: 18px;
    font-weight: 600;
    flex: 1;
    background-color: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 10px;
    padding: 60px 20px;
    box-shadow: 0 30px 50px -20px rgba(0, 40, 80, 0.25),
    0 8px 20px rgba(0, 20, 40, 0.08),
    inset 0 1px 1px rgba(255,255,255,0.6);
    border: 1px solid rgba(255,255,255,0.6);
    max-width: 1000px;
    width: fit-content;
    margin: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.6s;
  }
.button-showcase:hover{
  background: #d9dadd;
  transition: all 0.6s;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/UserInfo/UserInfo.vue